import { ActionReducerMapBuilder } from '@reduxjs/toolkit';

import * as actions from '../actions';
import { MessageType } from '../types';
import { PubnubState } from '..';

export const deleteMessageBuilder = (builder: ActionReducerMapBuilder<PubnubState>) => {
  return builder
    .addCase(actions.deleteMessage.pending, (state) => {
      state.isBusy = true;
    })
    .addCase(actions.deleteMessage.fulfilled, (state, action) => {
      if (action.payload.messageType === MessageType.RAISE_HAND) {
        state.currentRaiseHandMsgTT = null;
      }

      if (action.payload.messageType === MessageType.REACTION) {
        state.currentReactionMsgTT = null;
      }

      state.isBusy = false;
    })
    .addCase(actions.deleteMessage.rejected, (state) => {
      state.isBusy = false;
    });
};
